import React, { useState, useEffect, useRef } from 'react';
import Globe from './Globe';
import { feature } from 'topojson-client';
import '../../styles/App.css';
import { useNavigate } from 'react-router-dom';

function HomeGlobe() {
  const navigate = useNavigate();

  const [worldData, setWorldData] = useState(null);
  const containerRef = useRef(null);

  // Stan na rzeczywiste wymiary kontenera globusa
  const [globeDimensions, setGlobeDimensions] = useState({ width: 800, height: 500 });

  const handleCountryClick = (country) => {
    const countryCode = country?.id || country?.properties?.ISO_A2 || country;
    const userId = localStorage.getItem('userId');

    if (!userId) {
      // Niezalogowany -> Przekierowanie do widoku gościa
      navigate('/dolacz', { state: { selectedCountryCode: countryCode } });
    } else {
      // Zalogowany -> Normalne przejście do wpisów z wybranego kraju
      localStorage.setItem("selectedCountryCode", countryCode);
      navigate('/wpis', { state: { id: countryCode } });
    }
  };

  useEffect(() => {
    fetch('/world-data.json')
      .then(res => res.json())
      .then(topojsonData => {
        const convertedData = feature(topojsonData, topojsonData.objects.countries);
        setWorldData(convertedData);
      });
  }, []);

  // Funkcja mierząca div kontenera
  useEffect(() => {
    const updateDimensions = () => {
      if (containerRef.current) {
        setGlobeDimensions({
          width: containerRef.current.offsetWidth,
          height: containerRef.current.offsetHeight
        });
      }
    };

    updateDimensions();
    window.addEventListener('resize', updateDimensions);

    return () => window.removeEventListener('resize', updateDimensions);
  }, []);

  // Blokada domyślnego przewijania kółkiem myszy
  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    const handleWheel = (e) => {
      e.preventDefault();
    };

    container.addEventListener('wheel', handleWheel, { passive: false });
    container.addEventListener('touchmove', handleWheel, { passive: false });

    return () => {
      container.removeEventListener('wheel', handleWheel);
      container.removeEventListener('touchmove', handleWheel);
    };
  }, []);


  return (
    <div>
      <section id="eksploruj" className="hero-section">
        <div className="globe-wrapper" ref={containerRef}>
          <Globe
            worldData={worldData}
            width={globeDimensions.width}
            height={globeDimensions.height}
            onPolygonClick={handleCountryClick}
          />
        </div>
      </section>
    </div>
  );
}

export default HomeGlobe;